import { useLocale } from '~/contexts/LocaleContext'
import { getTranslation } from '~/lib/i18n-utils'
import { useEffect } from 'react'

interface TimeoutModalProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

export default function TimeoutModal({ isOpen, onClose, children }: TimeoutModalProps) {
  const { locale } = useLocale()
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[200]">
      <div className="fixed inset-0 bg-black/50" />
      <div className="fixed left-1/2 top-1/2 w-full max-w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-lg bg-white p-4">
        {children}
      </div>
    </div>
  )
}
